import { useSelector } from "react-redux";
// import Logo from "../assets/xxx";
import Logo1 from "../assets/willow-logo-removebg.png";
import eth from "../assets/eth.svg";
import Blockies from "react-blockies";
import {useDispatch} from 'react-redux';
import config from "../config.json";

import {
    loadAccount
} from "../store/interactions";



const Navbar = ()=>{
    const account = useSelector(state => state.provider.account);
    const chainId = useSelector(state => state.provider.chainId);
    const balance = useSelector(state=> state.provider.balance);
    const provider = useSelector(state => state.provider.connection);
    const dispatch = useDispatch();

    const connectHandler=async()=>{
        // load the account
        await loadAccount(dispatch,provider);
    }

    const networkHandler = async(event)=>{

        await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params:[{chainId: event.target.value}]
        })

        
    }


    return(
        <div className="exchange__header grid">
            <div className="exchange__header--brand flex">
                <img  src={Logo1} className="logo max-w-32 max-h-50" alt="Logo"></img>
                &nbsp;
                {/* <h1 style={{fontFamily: 'PopArt', fontWeight: '1200', fontSize:'300%'}}> EPIC DeX </h1> */}
                <h1 style={{fontFamily: '', fontWeight: '1200', fontSize:'300%'}}> willow </h1>
            </div>

            <div className="exchange__header--networks flex">

                <img  src={chainId && config[chainId] ? config[chainId].exchange.chainimg : ''} 
                alt="ETH Logo" 
                className="max-w-12 max-h-12" ></img>
                {
                    chainId && 
                    (
<select 
    name="networks" 
    id="networks" 
    value={config[chainId] ? `0x${chainId.toString(16)}` : `0`} 
    onChange={networkHandler}
    className="appearance-none bg-transparent border border-blue-500 text-blue-500 py-2 px-4 focus:outline-none focus:border-blue-700 transition ease-in-out duration-300 text-lg  "
    title="Click">
    <option value="0" disabled className="text-lg">Select Network</option>
    <option value="0xaa36a7" className="text-lg">Sepolia</option>

    {/* <option value="0x61" className="text-lg">BNB Testnet</option> */}

    {/* <option value="0x4268" className="text-lg">Holesky</option> */}
    {/* <option value="0xa0c71fd" className="text-lg">Blast Sepolia Testnet</option>
    <option value="0x397" className="text-lg">Mode Testnet</option> */}
</select>

                    )
                }
                
            </div>

     

            <div className="exchange__header--account flex">
        
        {/* <a className='button--sm' href="https://www.example.com" target="_blank" rel="noopener noreferrer">
            <p >Bridge</p>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"/>
  <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"/>
</svg>
        </a>&nbsp;

        <a className='button--sm' href="https://www.example.com" target="_blank" rel="noopener noreferrer">
            <p >Swap</p>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5"/>
  <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0z"/>
</svg>
        </a>&nbsp; */}
 
                {/* {
                    balance?(
                        <p><small>My Balance</small>{Number(balance).toFixed(4)} </p>
                    ):(
                        <p><small>My Balance</small></p>
                    )
                } */}
                {
                    balance?(
                        <p><small>Native Coin</small>{Number(balance).toFixed(2)} </p>
                    ):(
                        <p><small>Native Coin</small></p>
                    )
                }                

                {
                    account?(
                        <a 
                        href={config[chainId]? `${config[chainId].explorerUrl}/address/${account}`:`#`}
                        target="_blank"
                        rel="noreferrer"
                        >
                            {account.slice(0,5)+"..."+account.slice(38,42)}
                            <Blockies 
                            seed={account}
                            size={10}
                            scale ={3}
                            color="#2187D0"
                            bgColor="#F1F2F9"
                            spotColor="#767F92"
                            className="identicon cursor-pointer"
                            />
                        </a>
                    ):(
                        <button onClick={connectHandler} 
                        style={{ backgroundColor: 'red' }}
                        className="banner-text text-red-500 font-bold text-3xl animate-pulse"
                        >Connect</button>
                    )
                }     
            </div>

           

        </div>
    );
}

export default Navbar;